// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"391":"589437e8487c0aac","1755":"b39dbd97004bc4b5","7407":"c796f0bc88917655","8769":"c54b5dbab2fa7814"}[chunkId] + ".css";
};